export const friends = [
  {
    title: "Nicholas Tešija",
    description: "Nik is cool and my brother and he made music for some of my games!",
    links: [
      {
        name: "Website",
        link: "https://nik.horse/"
      }
    ],
  },
  {
  title: "Gerald Haagsma",
  description: "Jerry is cool and he makes popcorn!",
  links: [
    {
      name: "Website",
      link: "https://www.jerrypop.com/"
    }
  ],
},
{
    title: "Henry Quoc Tran",
    description: "Henry is cool and he makes games!",
    links: [
      {
        name: "Website",
        link: "https://qwook.io/"
      }
    ],
  },
]; 
